import { call, put, takeLatest } from 'redux-saga/effects';
import { emailConfigApi } from '../../../api/emailConfigApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eEmailConfigActionTypeIds } from './../../action-types/email/IDmEmailConfigActionTypes';
export function* emailConfigSaga(): any {
    yield takeLatest(eEmailConfigActionTypeIds.LOAD_START, loadWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(emailConfigApi.selectAll)
    if (res.is_success) {
        yield put(actions.emailWrapper.dmEmailConfig.LOAD_SUCCCES(res.data))
    } else {
        yield put(actions.emailWrapper.dmEmailConfig.LOAD_ERROR(res.message ?? "Error"))
    }
}
